import { Store } from '@sama/app-state';
import { find, forOwn, omitBy } from '@sama/micro-dash';
import { ShapeState } from '../../../../cross-team-shared/annotation/shared/state/shape-state';
import { ObjectWith } from '../../../../cross-team-shared/types/misc';
import { AnswerOption } from '../../../../team-apis/otterdam/answer-option';
import { FrameSpecificTag } from '../../../../team-apis/otterdam/answers/shape-typings';

export function removeDynamicTags(
  store: Store<ShapeState>,
  startFrameNumber: number,
  endFrameNumber: number,
  fusedOptions?: AnswerOption[],
) {
  let dynamicTagsRemovedCount = 0;
  const dynamicTags: ObjectWith<FrameSpecificTag[]> = {};
  forOwn(store.state().dynamic_tags, (tags, tagName) => {
    // @ts-ignore -- fix me
    dynamicTags[tagName] = tags.filter((tag) => {
      if (
        tag.frame_number < startFrameNumber ||
        tag.frame_number > endFrameNumber
      ) {
        return true;
      }

      if (fusedOptions && !find(fusedOptions, ({ name }) => name === tagName)) {
        return true;
      }

      dynamicTagsRemovedCount++;
      return false;
    });
  });

  if (dynamicTagsRemovedCount) {
    store.assign({
      dynamic_tags: clearEmptyTags(dynamicTags),
    });
  }
  return dynamicTagsRemovedCount;
}

function clearEmptyTags(
  dynamicTags: ObjectWith<FrameSpecificTag[]>,
): ObjectWith<FrameSpecificTag[]> {
  return omitBy(dynamicTags, (tags) => tags.length === 0);
}
